import config from "../constants/config";

const app = (state = config.initialState.app, action) => {
  switch (action.type) {
    case "TOGGLE_HOW_TO":
      return {
        ...state,
        showHowTo: action.showHowTo,
      };
    case "SCREEN_RESIZE":
      return {
        ...state,
        screenWidth: action.width,
        screenHeight: action.height,
      };
    case "SET_GRID_DIMENSIONS":
      return {
        ...state,
        gridWidth: action.gridWidth,
        gridHeight: action.gridHeight,
      };
    case "CHANGE_TAB":
      return {
        ...state,
        tabIndex: action.tabIndex,
      };
    case "REVIEW_SHOWN":
      return {
        ...state,
        reviewShown: action.reviewShown,
      };
    case "LOAD_GAME":
      return {
        ...state,
        tabIndex: 0,
      };
    case "NEW_GAME":
      return {
        ...state,
        titleScreen: false,
        tabIndex: 0,
      };
    case "TOGGLE_TITLE_SCREEN":
      return {
        ...state,
        titleScreen: !state.titleScreen,
      };
    case "SET_NEW_GRID_MENU":
      return {
        ...state,
        newGridMenu: action.newGridMenu,
      };
    case "SET_EQUATION_DIV":
      return {
        ...state,
        equationDiv: action.div,
      };
    case "SET_APP_THEME":
      return {
        ...state,
        theme: action.theme,
      };
    default:
      return state;
  }
};

export default app;
